import { useSelector, useDispatch } from "react-redux";
import FormContainer from "components/form/FormContainer";
import { InvestorsReducerActions } from "reducers/investorsReducer";
import ROUTES from "constants/Routes";

const InvestorsNewMember = () => {
  const formContent = {
    header: "Add New Investor",
    inputs: [
      {
        label: "Name",
        fieldName: "name",
        required: true,
        avatar: "member",
      },
      {
        label: "Title/Organization",
        fieldName: "description",
      },
      {
        label: "Website URL",
        fieldName: "website_url",
        type: "url",
      },
      {
        label: "LinkedIn URL",
        fieldName: "linkedin_url",
        type: "url",
      },
      {
        label: "Twitter URL",
        fieldName: "twitter_url",
        type: "url",
      },
      {
        label: "Image",
        fieldName: "image",
        type: "file",
        avatar: "member",
      },
    ],
  };

  const dispatch = useDispatch();
  const { setNewInvestorData, saveNewInvestor } = InvestorsReducerActions;
  const kit = useSelector((state) => state.auth.currentKit);
  const investorData = useSelector((state) => state.investors.newInvestor);

  const setNewInvestor = (fieldName, value) => {
    dispatch(setNewInvestorData({ ...investorData, [fieldName]: value }));
  };

  const handleSubmit = () => {
    dispatch(saveNewInvestor(kit, investorData));
  };

  return (
    <FormContainer
      formContent={formContent}
      data={investorData}
      setNewData={setNewInvestor}
      handleSubmit={handleSubmit}
      fileUpload={true}
      listPath={`${ROUTES.SETTINGS_PREFIX}${ROUTES.INVESTORS}`}
    />
  );
};

export default InvestorsNewMember;
